/**
 * Web stub for SplashScreen
 */

export default {
  hide: () => Promise.resolve(),
  show: () => Promise.resolve(),
};
